import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxisState } from "./analytical-axis-state.model";

/** Statut analytique d'un porteur au sein du statut d'un document. */
export class AnalyticalCarrierStatus extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalCarrierStatus';

    private _axes!: AnalyticalAxisState[];
    private _carrierId!: number;
    private _carrierType!: string;

    public get axes(): AnalyticalAxisState[] {
        return this._axes;
    }

    public set axes(value: any) {
        this._setValue('_axes', value, 'AnalyticalAxisState');
    }

    public get carrierId(): number {
        return this._carrierId;
    }

    public set carrierId(value: any) {
        this._setValue('_carrierId', value, 'integer');
    }

    public get carrierType(): string {
        return this._carrierType;
    }

    public set carrierType(value: any) {
        this._setValue('_carrierType', value, 'string');
    }
}
